// Implements a library to help in loading recaptcha and registering elements
// Google recaptchas will only bind to one element per page unless you use JS, so we're going to use JS

// should only be called after google recaptcha loads
export function register(element, callback) {
  element.a_recaptcha_id = grecaptcha.render(element, {
    sitekey: $recaptcha_invisible_key,
    size: 'invisible',
    badge: 'bottomright',
    isolated: true,
    callback: (r) => {
      if (callback) {
        callback(r);
      }
    },
  });
}

export function reset(element) {
  grecaptcha.reset(element.a_recaptcha_id);
}

export function execute(element) {
  grecaptcha.execute(element.a_recaptcha_id);
}

export function moveBadgeToBody() {
  moveBadgeTo(document.querySelector('body'));
}

export function moveBadgeTo(element) {
  const badge = document.querySelector(
    '.grecaptcha-badge[data-style="bottomright"]',
  );
  const textarea = badge.querySelector('textarea');

  if (textarea !== null) {
    badge.parentNode.parentNode.appendChild(badge.querySelector('textarea'));
    badge.style.zIndex = '10000';
  }

  element.appendChild(badge.parentNode);

  const hidden_right = badge.style.right;
  badge.onmouseenter = () => {
    badge.style.right = '4px';
  };
  badge.onmouseleave = () => {
    badge.style.right = hidden_right;
  };
}

export function moveBadgeWhenVisible(parent, badgeTarget = parent) {
  let previouslyVisible = false;

  function handleVisChange() {
    const visible = parent.offsetParent !== null;
    if (visible === previouslyVisible) return;

    if (visible) {
      moveBadgeTo(badgeTarget);
    }

    previouslyVisible = visible;
  }

  handleVisChange();

  $(parent).add($(parent).parents()).observe('attributes', handleVisChange);
}

let recaptcha_loading_promise = null;
export function load() {
  if (!recaptcha_loading_promise) {
    recaptcha_loading_promise = include_google_recaptcha();
  }

  return recaptcha_loading_promise;
}

let callback_id = 0;
function include_google_recaptcha() {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.onerror = reject;

    // if called multiple times the callbacks should have a unique name
    callback_id++;
    window['g_recaptcha_loaded' + callback_id] = resolve;

    script.src =
      'https://recaptcha.net/recaptcha/api.js?onload=' +
      'g_recaptcha_loaded' +
      callback_id +
      '&render=explicit';
    document.head.appendChild(script);
  });
}
